
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import FigureItem  from "components/FigureItem";
import NuCheckbox from "components/nubox/NuCheckbox"
import NuConfirm from "components/nubox/Box/NuConfirm";
import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
  
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class TablaNotasCentralFin extends React.Component {
  state = {

    modalImagen: false,
    
    fecha:'',
    bimestre:0,
    form: Object.assign({}, initialForm),

    dataList: [],/* lista  */
    //{"col":1, "label":'A1', 'id_asisfe':145 }
    
  };
  //---------------- CONTEXT API ------------------
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }  
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({dataList:[]});
    
    
    this.cargar_data();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    //let id_asisfe = this.props.params.id;

    let bimestre = this.props.params.id;
    this.setState({bimestre: bimestre})
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;              
      //------------------------------------------------

      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
      

    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  //-------------- cambiamos valor en la tabla
  handleCellChange=(index, columnId, value)=>{
    const newData = [...this.state.dataList];
    newData[index][columnId] = value;
    //this.setState({ datalist: newData });
    //solo tenemos que dejar pasar si es numero entero
    
    //---------------------
    
    //----------------------
    //let newData1 = this.calcular(newData, index);
        
    this.setState({ datalist: newData });
    
    //console.log(newData);
    //setData({  data: newData    });
    
  }
  //------------------------------------------
  //--- solo calculamos la fila
  
  
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,

   */
  cargar_data=()=>{
    console.log("cargar_data")
    //let id_est = this.props.store.user.id_est;
    let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;
    
    

    let param = { 
      id_mate: id_mate,
      id_peri: id_peri,
    
    }

    console.log(param)
    axios2.post("tabla_notas_central_get_list", param)
    .then(res => {
        console.log("tabla_notas_central_get_list")
        console.log(res.data.tabla)
        if(res.data.tabla.length>0){ 
            this.setState({dataList: res.data.tabla,
              
            });
            //this.setState({columnsA: res.data.columnsA});
        }else{
          this.setState({dataList: [] });
          
            //NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-----------------------------------------
  // retorna id_mate, nombre, sigla
  guardar_click=()=>{
    console.log("guardar_click");
    console.log("")
    
    this.save();
  }
  //---si el campo tiene valor vacio, lo convierte a 0
  normalizar=(num)=>{
    if(num==="") return 0;
    return num;
  }
  //-----------------------------------
  /*"id_progra": 36498,
    "p1": 0,
    "p2": 0,
    "p3": 0,
    "prom_parciales": 0,
    "practicas": 0,
    "prom_practicas": 0,
    "ex_final": 0,
    "prom_ex_final": 0,
    "nota_final": 0,*/
  /* normalizamos valores antes de enviar a el server */
 
  //------------------------------------
  finalizar_click =(e)=>{
    e.preventDefault();

    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de finalizar el llenado? \n Una vez finalizado, no se podra modificar.',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        console.log("confirmar finalizar")
        this.finalizar();
        //let idd = item.id_carre;
        //this.modalRef.current.eliminar(idd);
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })
  }
  //-----------------------------------
  finalizar=()=>{
    const user = this.props.store.user;
    const materia = this.props.store.materia;
    //console.log(this.state.dataList)
    let bimestre = parseInt( this.props.params.id);

    let param = { 
      id_peri: user.id_peri,
      id_mate: materia.id_mate,
      id_doc: user.id_doc,
      //bimestre: bimestre,
      
      
    };
    console.log(param);
    
    axios2.post("tabla_notas_central_fin_finalizar", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            
            NotificationManager.success(res.data.men);  
            this.props.navigate('/notasd');         
        }else{
            NotificationManager.error(res.data.men);
            
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });

  }
  //-----------------------------------
  save =() =>{

    let param = { 
    
      
      tabla:  JSON.stringify( this.state.dataList )
    };

    console.log(param);
    
    axios2.post("tabla_notas_store", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            
            NotificationManager.success(res.data.men);         
        }else{
            NotificationManager.error(res.data.men);
            
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //-------------------------------------
  //------------------------------
  render() {
    let materia = this.props.store.materia
    let user = this.props.store.user
    return(
      <div>
        {/* ---   --- */}
        { 
          //JSON.stringify(this.state.form.cant_teo)
        }
        <div className="escritorio center-align p-3">

          <div className="row">
            <div className="col-md-7">
              <h3> PLANILLA DE NOTAS CENTRALIZADA { user.periodo } </h3>
              
              &nbsp;
              <Button 
                  className="btn btn-danger" 
                  onClick={ this.finalizar_click } >
                FINALIZAR NOTAS
              </Button>
              <p>
                Sigla: { materia.sigla }<br />
                Materia: { materia.nombre } /G { materia.grupo } <br />
                Periodo: { user.periodo } <br />
                
                { /* Fecha: { this.state.fecha }<br/> */}
              </p>
            </div>

            <div className="col-md-5">
             
            </div>

          </div>
        <div class="table-responsive">
          <table className="tabla_azul  table-striped table-hover ">
            <thead>
              <tr>
                <th rowSpan={2} className="text-center cell_celeste">Nro.</th>
                <th rowSpan={2} className="text-center cell_celeste">Apellidos y Nombres</th>
                <th rowSpan={2} className="text-center cell_celeste">C.I.</th>
                <th colSpan={3} className="cell_celeste">1er BIMESTRE</th>
                <th colSpan={3} className="cell_celeste">2er BIMESTRE</th>
                <th colSpan={3} className="cell_celeste">3er BIMESTRE</th>
                <th colSpan={3} className="cell_celeste">4er BIMESTRE</th>
                <th rowSpan={2} className="">PROMEDIO</th>
                <th rowSpan={2} className="">PORC. ASIS.</th>
                <th rowSpan={2} className="">PRUEBA RECUP.</th>
                <th rowSpan={2} className="">PROMEDIO FINAL</th>
                <th rowSpan={2} className="">OBS</th>
              </tr>
              <tr>
                  {/*<th width="80px">Nro</th>*/}
                  {/*<th>Nro. Doc.</th>*/}
                  {/*<th>Apellidos y Nombres</th>*/}
                  {/*<th>C.I.</th>*/}
                  <th>Nota Teo.</th>
                  <th>Nota Prac.</th>
                  <th>Nota 1er Trim.</th>

                  <th>Nota Teo.</th>
                  <th>Nota Prac.</th>
                  <th>Nota 2do Trim.</th>
                  
                  <th>Nota Teo.</th>
                  <th>Nota Prac.</th>
                  <th>Nota 3er Trim.</th>

                  <th>Nota Teo.</th>
                  <th>Nota Prac.</th>
                  <th>Nota 4to Trim.</th>

                  {/*<td className="cell_rosado">Promedio</td>*/}
                  {/*<td className="cell_rosado">Proc. Asist.</td>*/}
                  {/*<td className="">Prueba Recupera.</td>*/}
                  {/*<th>Nota Final</th>*/}
                  {/*<th>Obs.</th>*/}
              </tr>
            </thead>
            <tbody>
                
                {this.state.dataList.map((item,index) => ( 
                    <tr key={index}>
                      <td>{ index+1 }
                        { /* item.id_progra */}
                      </td>
                      {/*<td>{ item.nro_doc }</td>*/}
                      <td>{ item.nomape_tmp }</td>
                      <td>
                        { item.nro_doc}
                      </td>
                      <td className="text-center"> {item.b1_nt} </td>
                      <td className="text-center"> {item.b1_np} </td>
                      <td className="text-center cell_rosado"> {item.b1_nota} </td>

                      <td className="text-center"> {item.b2_nt} </td>
                      <td className="text-center"> {item.b2_np} </td>
                      <td className="text-center cell_rosado"> {item.b2_nota} </td>

                      <td className="text-center"> {item.b3_nt} </td>
                      <td className="text-center"> {item.b3_np} </td>
                      <td className="text-center cell_rosado"> {item.b3_nota} </td>

                      <td className="text-center"> {item.b4_nt} </td>
                      <td className="text-center"> {item.b4_np} </td>
                      <td className="text-center cell_rosado"> {item.b4_nota} </td>

                      <td className="text-center "> {item.promedio} </td>
                      <td className="text-center "> {item.por_asis} </td>
                      <td className="text-center "> {item.prueba_recu} </td>
                      <td className="text-center "> {item.nota_final} </td>
                      <td className="text-center "> {item.obs} </td>
                      {/**------------------------------------- */}                                  
                    </tr>
                ))}
                
            </tbody>
          </table>
        </div>

        <div className="pt-2">
          
        </div>


      </div>
        

        <NotificationContainer/>
        <NuConfirm   ref={ this.refNuConfirm }    />
      </div>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(TablaNotasCentralFin);